import type { GetDocumentRecipientsQuery } from '@graphql/__generated__/graphql';

export type BrochureRecipient = NonNullable<
  GetDocumentRecipientsQuery['document_recipients']
>['recipients'][number];

export const getRecipientOpenTime = (recipient: BrochureRecipient): number => {
  if (recipient.last_open_at == null) {
    return 0;
  }

  const time = Date.parse(recipient.last_open_at);
  return Number.isNaN(time) ? 0 : time;
};
